import React from 'react';
import * as Icons from 'library/icons/index';
import { string } from 'prop-types';
import BrokenIcon from 'library/icons/x-in-circle.svg';

const IconMapper = ({ icon, ...props }) => {
  const Component = Icons[icon] || BrokenIcon;

  return <Component {...props} />;
};

IconMapper.propTypes = {
  icon: string,
};

export default IconMapper;
